export const translations = {
  nl: {
    // Header
    services: "Diensten",
    howItWorks: "Werkwijze",
    why: "Waarom",
    contact: "Contact",
    
    // Hero
    openedOn: "Geopend op 08.04.2026",
    forPolishCommunity: "Speciaal voor de Poolse gemeenschap",
    heroTitle: "Jouw brug naar duidelijkheid",
    heroSubtitle: "Wij helpen met brieven, administratie en contact met Nederlandse instanties.",
    heroTagline: "Snel, duidelijk en zonder stress",
    ctaPrimary: "Neem direct contact op",
    ctaSecondary: "Bekijk diensten",
    newBadge: "Nieuw",
    since: "Sinds 08.04.2026",
    
    // Stats
    stats: {
      reactTime: "Reactietijd",
      daysPerWeek: "Dagen per week",
      services: "Verschillende diensten",
      custom: "Op maat"
    },
    
    // Services
    servicesTitle: "Hoe kunnen wij helpen?",
    servicesSubtitle: "Bij WorkHelp NL ondersteunen wij particulieren en zzp'ers bij het regelen van administratieve en praktische zaken in Nederland.",
    servicesTag: "Onze diensten",
    
    services1: {
      title: "Brieven uitleggen en vertalen",
      description: "Wij helpen je begrijpen wat er in je post staat en vertalen ingewikkelde brieven naar duidelijke taal",
      benefits: ["Directe uitleg", "Geen verwarring", "Volledige duidelijkheid"]
    },
    services2: {
      title: "Formulieren invullen",
      description: "Samen zorgen we dat alles correct ingevuld wordt en niets over het hoofd wordt gezien",
      benefits: ["Correcte gegevens", "Tijdsbesparing", "Geen fouten"]
    },
    services3: {
      title: "Contact met instanties",
      description: "Gemeente, belastingdienst en zorgverleners - wij regelen het contact en zorgen voor duidelijke communicatie",
      benefits: ["Direct contact", "Professioneel", "In jouw belang"]
    },
    services4: {
      title: "Afspraken maken",
      description: "Wij plannen en regelen belangrijke afspraken voor je en zorgen dat je voorbereid bent",
      benefits: ["Goed gepland", "Geen gemiste afspraken", "Volledig geregeld"]
    },
    services5: {
      title: "Administratie organiseren",
      description: "Overzicht en structuur in al je documenten zodat je altijd weet waar alles staat",
      benefits: ["Overzichtelijk systeem", "Easy toegang", "Geen chaos"]
    },
    services6: {
      title: "Ondersteuning voor zelfstandigen",
      description: "Hulp bij facturen, communicatie en administratief overzicht speciaal voor ZZP'ers",
      benefits: ["Meer tijd voor werk", "Professioneel", "Volledig ontlast"]
    },
    
    // About
    aboutTag: "Over WorkHelp NL",
    aboutTitle: "De brug tussen jou en het systeem",
    aboutText1: "WorkHelp NL is er voor mensen die moeite hebben met de Nederlandse taal of het systeem.",
    aboutText1Bold: "Wij zorgen ervoor dat alles duidelijk wordt en correct geregeld wordt.",
    aboutQuote: "Wij fungeren als een brug tussen jou en bedrijven, overheidsinstanties en andere organisaties.",
    aboutText2: "Met persoonlijke aandacht en duidelijke communicatie helpen wij je stap voor stap verder.",
    aboutCard1: "Op maat",
    aboutCard1Sub: "Persoonlijke aanpak",
    aboutCard2: "Maatwerk",
    aboutCard2Sub: "Jouw situatie is uniek",
    
    // Process
    processTag: "Werkwijze",
    processTitle: "Zo werken wij samen",
    processSubtitle: "Van eerste contact tot oplossing - helder en transparant",
    
    process1: {
      title: "Contact opnemen",
      description: "Je neemt contact met ons op via WhatsApp, telefoon of e-mail"
    },
    process2: {
      title: "Situatie uitleggen",
      description: "Je legt uit waar je hulp bij nodig hebt"
    },
    process3: {
      title: "Analyse & Uitleg",
      description: "Wij bekijken jouw situatie en geven een duidelijke uitleg"
    },
    process4: {
      title: "Samen regelen",
      description: "Met jouw toestemming regelen wij wat nodig is"
    },
    process5: {
      title: "Op de hoogte blijven",
      description: "Jij blijft altijd op de hoogte van de voortgang"
    },
    
    // Why
    whyTag: "Waarom WorkHelp NL",
    whyTitle: "Jouw betrouwbare partner",
    
    why1: {
      title: "Duidelijke en eenvoudige uitleg",
      desc: "Geen ingewikkelde taal"
    },
    why2: {
      title: "Persoonlijke aanpak",
      desc: "Op maat gemaakt"
    },
    why3: {
      title: "Snelle communicatie",
      desc: "Binnen 24u reactie"
    },
    why4: {
      title: "Betrouwbare ondersteuning",
      desc: "Altijd bereikbaar"
    },
    why5: {
      title: "Ervaring met instanties",
      desc: "We kennen het systeem"
    },
    
    // Pricing
    pricingTag: "Tarieven",
    pricingTitle: "Transparante prijzen",
    pricingSubtitle: "Kies wat bij je past - losse diensten of een abonnement",
    
    oneTimeServices: "Losse diensten",
    subscriptions: "Abonnementen",
    perMonth: "per maand",
    popular: "Populair",
    
    // Subscription plans
    basicPlan: "BASIC",
    basicPrice: "79",
    basicDesc: "Voor kleine vragen en ondersteuning",
    basicFeature1: "Reactie binnen 24-48 uur",
    basicFeature2: "Ca. 2 uur per maand",
    basicFeature3: "Eenvoudige vragen",
    
    standardPlan: "STANDARD",
    standardPrice: "139",
    standardDesc: "Voor regelmatige ondersteuning",
    standardFeature1: "Reactie binnen 24-48 uur",
    standardFeature2: "Ca. 4 uur per maand",
    standardFeature3: "Contact met instanties",
    
    premiumPlan: "PREMIUM",
    premiumPrice: "229",
    premiumDesc: "Intensieve en complexe hulp",
    premiumFeature1: "Prioriteit behandeling",
    premiumFeature2: "Ca. 8-10 uur per maand",
    premiumFeature3: "Actieve begeleiding",
    
    // One-time services  
    service1Name: "Brief uitleggen (tot 2 pagina's)",
    service1Price: "€25",
    service2Name: "Eenvoudig formulier",
    service2Price: "€30-€50",
    service3Name: "Complex formulier",
    service3Price: "€60-€120",
    service4Name: "Contact met instantie",
    service4Price: "€35",
    service5Name: "Afspraak maken",
    service5Price: "€20",
    
    extraInfo: "Extra uren",
    extraInfoSub: "€40/uur (abonnees) • €45/uur (zonder abonnement)",
    pricesExclVAT: "Alle prijzen zijn inclusief BTW",
    choosePlan: "Kies dit pakket",
    
    // FAQ
    faqTag: "Veelgestelde vragen",
    faqTitle: "Heb je nog vragen?",
    
    faq1: {
      question: "Moet ik Nederlands spreken?",
      answer: "Nee, wij helpen juist mensen die de taal niet goed spreken. We communiceren in een taal die jij begrijpt en zorgen ervoor dat alles helder is."
    },
    faq2: {
      question: "Regelen jullie alles voor mij?",
      answer: "Wij helpen en ondersteunen bij het regelen van zaken, maar jij blijft altijd eindverantwoordelijk. We nemen geen beslissingen zonder jouw toestemming."
    },
    faq3: {
      question: "Hoe kan ik contact opnemen?",
      answer: "Je kan ons bereiken via WhatsApp, telefoon of e-mail. We reageren meestal binnen 24 uur en plannen dan een eerste gesprek in."
    },
    faq4: {
      question: "Wat kosten jullie diensten?",
      answer: "We werken met transparante prijzen op uurbasis. Na het eerste kennismakingsgesprek krijg je een duidelijke offerte. Geen verborgen kosten."
    },
    
    // Contact
    contactTag: "Neem contact op",
    contactTitle: "Klaar om te beginnen?",
    contactSubtitle: "Heb je hulp nodig of een vraag? Neem gerust contact op.",
    
    whatsapp: "WhatsApp",
    whatsappDesc: "Direct contact via WhatsApp",
    phone: "Telefoon",
    phoneDesc: "Bel ons tijdens kantooruren",
    email: "E-mail",
    emailDesc: "Stuur ons een bericht",
    
    responseTime: "Reactietijd binnen 24 uur",
    responseTimeDesc: "We streven ernaar om binnen 24 uur te reageren op alle berichten",
    
    // Footer
    footerAbout: "Jouw betrouwbare partner voor administratieve ondersteuning in Nederland. Geopend op 08.04.2026.",
    quickLinks: "Snelle links",
    legalLinks: "Documenten",
    termsConditions: "Algemene voorwaarden",
    privacy: "Privacy",
    pricing: "Tarieven",
    whyWorkHelp: "Waarom WorkHelp NL",
    personalApproach: "Persoonlijke aanpak",
    copyright: "© 2026 WorkHelp NL - Jouw brug naar duidelijkheid"
  },
  
  pl: {
    // Header
    services: "Usługi",
    howItWorks: "Jak to działa",
    why: "Dlaczego my",
    contact: "Kontakt",
    
    // Hero
    openedOn: "Otwarte od 08.04.2026",
    forPolishCommunity: "Specjalnie dla Polaków w Holandii",
    heroTitle: "Pomoc w holenderskiej administracji",
    heroSubtitle: "Pomagamy z listami, dokumentami i kontaktem z urzędami. Po polsku, bez stresu.",
    heroTagline: "Wiemy jak trudna jest holenderska biurokracja",
    ctaPrimary: "Napisz do nas",
    ctaSecondary: "Zobacz co robimy",
    newBadge: "Nowa",
    since: "Od kwietnia 2026",
    
    // Stats
    stats: {
      reactTime: "Odpisujemy",
      daysPerWeek: "Jesteśmy dostępni",
      services: "Różnych usług",
      custom: "Indywidualnie"
    },
    
    // Services
    servicesTitle: "W czym możemy pomóc?",
    servicesSubtitle: "Pomagamy Polakom mieszkającym w Holandii załatwić wszystko co związane z urzędami, dokumentami i administracją.",
    servicesTag: "Co robimy",
    
    services1: {
      title: "Tłumaczenie i wyjaśnianie listów",
      description: "Dostałeś list od Belastingdienst, gminy czy UWV i nie wiesz o co chodzi? Przetłumaczymy i wytłumaczymy prostym językiem",
      benefits: ["Szybko", "Po polsku", "Zrozumiale"]
    },
    services2: {
      title: "Pomoc z formularzami",
      description: "Wypełnimy razem każdy formularz - od toeslag po aangifte. Sprawdzimy czy wszystko się zgadza",
      benefits: ["Bez błędów", "Oszczędność czasu", "Pewność"]
    },
    services3: {
      title: "Kontakt z urzędami",
      description: "Zadzwonimy do gemeentes, Belastingdienst czy CAK. Wytłumaczymy Twoją sprawę i dopilnujemy wszystkiego",
      benefits: ["Po holendersku", "Profesjonalnie", "W Twoim imieniu"]
    },
    services4: {
      title: "Umawianie wizyt",
      description: "Umówimy wizytę u lekarza, w urzędzie czy gdziekolwiek potrzebujesz. Przygotujemy Cię do rozmowy",
      benefits: ["Wszystko załatwione", "Nic nie przegapisz", "Spokojnie"]
    },
    services5: {
      title: "Porządek w papierach",
      description: "Pomożemy uporządkować dokumenty, faktury i wszystkie papiery żeby mieć wszystko pod ręką",
      benefits: ["Przejrzyście", "Łatwy dostęp", "Zero chaosu"]
    },
    services6: {
      title: "Pomoc dla ZZP",
      description: "Samozatrudnienie w Holandii to masa papierkowej roboty. Pomożemy z fakturami, VAT, aangifte i całą resztą",
      benefits: ["Więcej czasu na pracę", "Wszystko zgodne z prawem", "Spokój"]
    },
    
    // About
    aboutTag: "O nas",
    aboutTitle: "Twój polski pomocnik w Holandii",
    aboutText1: "Wiemy jak trudno jest żyć w obcym kraju kiedy nie rozumiesz języka i systemu.",
    aboutText1Bold: "Dlatego pomagamy Polakom załatwić wszystko co urzędowe - szybko i po polsku.",
    aboutQuote: "Jesteśmy mostem między Tobą a holenderskimi urzędami. Rozmawiamy po polsku, załatwiamy po holendersku.",
    aboutText2: "Każda sprawa jest dla nas ważna. Tłumaczymy, dzwonimy, wypełniamy - robimy to czego potrzebujesz.",
    aboutCard1: "Indywidualnie",
    aboutCard1Sub: "Każdy ma inną sprawę",
    aboutCard2: "Po polsku",
    aboutCard2Sub: "Rozumiemy się",
    
    // Process
    processTag: "Jak to działa",
    processTitle: "Prosto i bez stresu",
    processSubtitle: "4 kroki do załatwienia sprawy",
    
    process1: {
      title: "Napisz do nas",
      description: "WhatsApp, telefon, email - jak Ci wygodnie. Powiedz w czym potrzebujesz pomocy"
    },
    process2: {
      title: "Opowiesz o sprawie",
      description: "Wysłuchamy, zrozumiemy i wytłumaczymy co trzeba zrobić"
    },
    process3: {
      title: "Ustalimy plan",
      description: "Powiemy Ci dokładnie co będziemy robić i ile to kosztuje. Bez ukrytych opłat"
    },
    process4: {
      title: "Załatwiamy sprawę",
      description: "Dzwonimy, piszemy, wypełniamy. Ty wiesz co się dzieje na każdym etapie"
    },
    process5: {
      title: "Trzymamy rękę na pulsie",
      description: "Dopóki wszystko nie będzie załatwione - jesteśmy z Tobą"
    },
    
    // Why
    whyTag: "Dlaczego my",
    whyTitle: "Rozumiemy Cię",
    
    why1: {
      title: "Mówimy po polsku",
      desc: "Bez kombinowania w obcym języku"
    },
    why2: {
      title: "Wiemy jak to jest",
      desc: "Sami przez to przeszliśmy"
    },
    why3: {
      title: "Odpisujemy szybko",
      desc: "Maksymalnie 24h"
    },
    why4: {
      title: "Można na nas liczyć",
      desc: "Jesteśmy dostępni 7 dni w tygodniu"
    },
    why5: {
      title: "Znamy holenderski system",
      desc: "Wiemy jak to wszystko działa"
    },
    
    // Pricing
    pricingTag: "Cennik",
    pricingTitle: "Przejrzyste ceny",
    pricingSubtitle: "Wybierz co Ci pasuje - pomoc jednorazowa czy abonament",
    
    oneTimeServices: "Pomoc jednorazowa",
    subscriptions: "Abonament",
    perMonth: "miesięcznie",
    popular: "Popularne",
    
    // Subscription plans
    basicPlan: "BASIC",
    basicPrice: "79",
    basicDesc: "Dla prostych pytań",
    basicFeature1: "Odpowiedź w 24-48h",
    basicFeature2: "Ok. 2 godziny/miesiąc",
    basicFeature3: "Proste sprawy",
    
    standardPlan: "STANDARD",
    standardPrice: "139",
    standardDesc: "Regularna pomoc",
    standardFeature1: "Odpowiedź w 24-48h",
    standardFeature2: "Ok. 4 godziny/miesiąc",
    standardFeature3: "Dzwonimy do urzędów",
    
    premiumPlan: "PREMIUM",
    premiumPrice: "229",
    premiumDesc: "Kompleksowa opieka",
    premiumFeature1: "Obsługa priorytetowa",
    premiumFeature2: "Ok. 8-10 godzin/miesiąc",
    premiumFeature3: "Ciągła pomoc",
    
    // One-time services
    service1Name: "Tłumaczenie listu (do 2 stron)",
    service1Price: "€25",
    service2Name: "Prosty formularz",
    service2Price: "€30-€50",
    service3Name: "Skomplikowany formularz",
    service3Price: "€60-€120",
    service4Name: "Telefon do urzędu",
    service4Price: "€35",
    service5Name: "Umówienie wizyty",
    service5Price: "€20",
    
    extraInfo: "Dodatkowe godziny",
    extraInfoSub: "€40/godz (abonament) • €45/godz (bez abonamentu)",
    pricesExclVAT: "Wszystkie ceny zawierają VAT",
    choosePlan: "Wybieram",
    
    // FAQ
    faqTag: "Pytania",
    faqTitle: "Najczęściej pytacie o...",
    
    faq1: {
      question: "Czy muszę mówić po holendersku?",
      answer: "Nie musisz! Właśnie po to jesteśmy - żeby pomóc tym którzy nie czują się pewnie z holenderskim. Rozmawiamy po polsku, a z urzędami po holendersku."
    },
    faq2: {
      question: "Czy załatwicie wszystko bez mojego udziału?",
      answer: "Pomożemy Ci w każdym kroku, ale ostateczna decyzja zawsze należy do Ciebie. Nic nie robimy bez Twojej zgody - wszystko ustalamy razem."
    },
    faq3: {
      question: "Jak mogę się z Wami skontaktować?",
      answer: "Najłatwiej przez WhatsApp, ale możesz też zadzwonić lub napisać maila. Odpisujemy zwykle tego samego dnia lub następnego."
    },
    faq4: {
      question: "Ile to kosztuje?",
      answer: "Ceny są przejrzyste - płacisz za godzinę pracy. Po pierwszej rozmowie dostaniesz dokładną wycenę. Żadnych ukrytych kosztów."
    },
    
    // Contact
    contactTag: "Kontakt",
    contactTitle: "Potrzebujesz pomocy?",
    contactSubtitle: "Napisz, zadzwoń lub wyślij WhatsAppa - odpowiemy szybko",
    
    whatsapp: "WhatsApp",
    whatsappDesc: "Najszybszy kontakt",
    phone: "Telefon",
    phoneDesc: "Dzwoń w godzinach pracy",
    email: "Email",
    emailDesc: "Napisz do nas",
    
    responseTime: "Odpisujemy w ciągu 24h",
    responseTimeDesc: "Zwykle jeszcze szybciej - często tego samego dnia",
    
    // Footer
    footerAbout: "Pomoc dla Polaków mieszkających w Holandii w kontaktach z urzędami i administracją. Działamy od kwietnia 2026.",
    quickLinks: "Menu",
    legalLinks: "Dokumenty",
    termsConditions: "Regulamin",
    privacy: "Prywatność",
    pricing: "Cennik",
    whyWorkHelp: "Dlaczego my",
    personalApproach: "Indywidualne podejście",
    copyright: "© 2026 WorkHelp NL - Pomoc po polsku w Holandii"
  }
};
